import styled from "styled-components";
import { media } from "../../utils/styles/media";

export const LikeInfluencerContainer = styled.div`
    
    svg{
        cursor: pointer;
        width: 100%;
        height: 100%;
    }
   
    svg:hover{
        path{
            fill: url(#grad1);
        } 
    }

    /**--------Responsive-------- */
    ${media.laptop}{
        /* svg{
            width: 80%;
            height: 80%;
        } */
    }
`